import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-pagelayout',
  templateUrl: './landing-pagelayout.component.html',
  styleUrls: ['./landing-pagelayout.component.scss']
})
export class LandingPagelayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
